export default {
    getAllContributors: state => {
        return state.contributors.data;
    },
    getSelectedDetailContributor: state => {
        return state.contributors.data.find(item => item.slug === state.contributors.selectedContributorForDetail);
    },
    getSelectedContributorAnswers: state => {
        return state.contributors.data.find(item => item.slug === state.contributors.selectedContributorForAnswers);
    },
    getContributorsIsLoading: state => {
        return state.contributors.dataLoading || state.contributors.categoriesLoading;
    },

};